var Clock = /** @class */ (function () {
    function Clock(dateConstructor) {
        this.dateConstructor = dateConstructor;
        this.millisecondsInMinute = 60000;
    }
    Clock.prototype.getBeginningOfTodayForTimeZone = function (timezone) {
        var currentDate = new this.dateConstructor();
        var delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        var currentInTimezone = new Date(currentDate.getTime() + delta);
        currentInTimezone.setHours(0, 0, 0, 0);
        var target = new Date(currentInTimezone.getTime() - delta);
        return target;
    };
    Clock.prototype.getTimeTillMidnight = function (timezone) {
        var currentDate = new this.dateConstructor();
        var delta = this.getDifferenceBetweenCurrentTimezoneAndSelected(currentDate, timezone);
        var currentInTimezone = new Date(currentDate.getTime() + delta);
        var midnight = new Date(currentInTimezone);
        midnight.setDate(midnight.getDate() + 1);
        midnight.setHours(0, 0, 0, 0);
        return midnight.getTime() - currentInTimezone.getTime();
    };
    Clock.prototype.getDifferenceBetweenCurrentTimezoneAndSelected = function (currentDate, selectedTimezone) {
        var browserTimezoneOffset = -currentDate.getTimezoneOffset() * this.millisecondsInMinute;
        var targetTimezoneOffset = selectedTimezone * 60 * this.millisecondsInMinute;
        return targetTimezoneOffset - browserTimezoneOffset;
    };
    return Clock;
}());
export { Clock };
//# sourceMappingURL=Clock.js.map